import React from 'react';
import StaticLayout from 'common/Layout/StaticLayout';
import { Box, Text } from 'common/styles';
import { __t } from 'common/i18n';
import ContactInfo from 'common/ContactInfo';
import styled from '@emotion/styled';
import FAQList from 'common/FAQAccordian';
import Seo from 'common/Seo';
import Breadcrumb from 'common/Breadcrumb';
import Head from 'next/head';
import { safeJsonLd } from '../common/utils/safeJsonLd';

const faqKeys = [
  'howـregister',
  'how_enter_discount_code',
  'faildـpay',
  'buyـsubscription',
  'pay',
  'foreignـcountry',
  'whyـbuyـsubscription',
  'cancelـsubscription',
  'enterـcontactـinfo',
  'resendـsms',
  'discountـcode',
  'platforms',
];

function stripHtml(html: string) {
  return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqKeys.map((key) => ({
    '@type': 'Question',
    name: __t(`static.faq.qs.${key}`),
    acceptedAnswer: {
      '@type': 'Answer',
      text: stripHtml(__t(`static.faq.aw.${key}`)),
    },
  })),
};

export default function Faq() {
  return <>
    <Seo
      title={`${__t('static_siteName')} | ${__t('common.faq')}`}
      description="پرسش‌های متداول درباره استفاده از فیلمنت، حساب کاربری، اشتراک و تماشای آنلاین فیلم و سریال"
      path="/faq"
    />
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: safeJsonLd(faqSchema) }}
      />
    </Head>
    <Breadcrumb items={[
      { name: __t('common.home'), url: '/' },
      { name: __t('common.faq'), url: '/faq' },
    ]} />
    <StaticLayout cover="/static/images/static_pages/faq_cover_img.jpg" title={__t('common.faq')}>
      <FAQList boxMarginBottom={8} />
      <Box pt={2}>
        <ResponsiveTitle mb={4} mt={8} align="center">{__t('static.faq.contactـinfo')}</ResponsiveTitle>
      </Box>
      <ContactInfo IconColor='#fff' />
    </StaticLayout>
  </>;
}

const ResponsiveTitle = styled(Text)(({ theme }) => ({
  fontWeight: 500,
  ...theme.font.responsiveSize(3),
}));
